// extracted by mini-css-extract-plugin
export var linkText = "_qz-0";